module.exports = __webpack_public_path__ + "assets/img/jisntou2.06e1fbfc.png";